import { Component, Input, Output, EventEmitter, HostListener, HostBinding, ViewEncapsulation } from '@angular/core';
import { coerceNumberProperty, coerceBooleanProperty } from '@angular/cdk/coercion';
import { NoticeItem } from '../../model/notice-item';

@Component({
    selector: 'notice-icon',
    templateUrl: './notice-icon.component.html',
    styleUrls: ['./notice-icon.css']
})
export class NoticeIconComponent {
    @Input()
    get data() { return this._data; }
    set data(value: any) {
        this._data = value;
    }
    private _data: NoticeItem[] = [];

    /** 图标上的消息总数 */
    @Input()
    get count() { return this._count; }
    set count(value: any) {
        this._count = coerceNumberProperty(value);
    }
    private _count: number;

    /** 图标不展示数字，只有一个小红点 */
    @Input()
    get dot() { return this._dot; }
    set dot(value: any) {
        this._dot = coerceBooleanProperty(value);
    }
    private _dot = false;

    @Input()
    get overflowCount() { return this._overflowCount; }
    set overflowCount(value: any) {
        this._overflowCount = coerceNumberProperty(value);
    }
    private _overflowCount: number;

    /** 弹出卡片加载状态 */
    @Input()
    get loading() { return this._loading; }
    set loading(value: any) {
        this._loading = coerceBooleanProperty(value);
    }
    private _loading = false;

    @Output() select = new EventEmitter<any>();
    @Output() clear = new EventEmitter<string>();
    @Output() loadData = new EventEmitter<any>();
    @Output() popoverVisibleChange = new EventEmitter<boolean>();

    /** 手动控制Popover显示 */
    @Input()
    get popoverVisible() { return this._popoverVisible; }
    set popoverVisible(value: any) {
        this._popoverVisible = coerceBooleanProperty(value);
    }
    private _popoverVisible = false;


    onVisibleChange(result: boolean) {
        this.popoverVisible = true;
        this.popoverVisibleChange.emit(result);
    }

    onLoadData(data) {
        this.loadData.emit(data);
    }

    onSelect(i: any) {
        this.select.emit(i);
    }

    onClear(title: string) {
        this.clear.emit(title);
    }
}
